
  import loaderComponent from '@/components/loaderComponent';
  import NoContent from '@/components/customer-content/NoContent'
  export default {
    layout: 'error-page',
    components: {
      NoContent,
    },
    head() {
      return {
        script: [{
          hid: "rzpay",
          rel: "dns-prefetch",
          src: "https://checkout.razorpay.com/v1/checkout.js",
          defer: true
        }],
        title: this.title + " | GoaApp",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'robots',
            name: 'robots',
            content: 'noindex'
          },
        ],
      }
    },
    data() {
      return {
        title: 'Checkout',
        checkoutDetails: null,
        availableCoupons: [],
        cartItems: null,
        loading: true,
        payment_id: null,
        order_id: null,
        userId: null,
        token: null,
        profile: null,
        orderDetails: null,
        orderButtonLoading: false,
        orderFailed: false,
        couponAppliedError: false,
        couponCode: null,
        applyCouponLoading: false,
        removeCouponLoading: false,
        selectedCartItem: 0,
        deleteCartItem: {
          loading: false,
          success: false,
          formError: null,
          errored: false
        },
        //Form error variables
        errors: {
          formError: null
        },
      };
    },
    // Check login token
    mounted() {
      if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
        if (localStorage.getItem("profile") != (null || undefined)) {
          this.profile = JSON.parse(localStorage.getItem("profile"));
        }
        this.getCheckoutDetails()
        //this.getAavailableCoupons()
      } else {
        this.$router.push({
          path: '/accounts/login/'
        })
      }
    },
    methods: {
      modalClose() {
        this.couponAppliedError = false;
        this.couponCode = null;
      },
      //GET ACTIVITIES THUMBNAIL IMAGE
      activitiesThumbnailImage(post) {
        if (post.logo) {
          return post.logo;
        } else {
          if (post.smallLogo)
            return post.smallLogo
          return '';
        }
      },
      //------------------------------------------- CART FUNCTIONS -------------------------------------------//
      isWeekendDate(ticketDate) {
        let pdate = new Date(ticketDate)
        var dayOfWeek = pdate ? pdate.getDay() : 1;
        return (dayOfWeek === 5) || (dayOfWeek === 6) || (dayOfWeek === 0);
      },
      // TO get CHECKOUT DETAILS
      getCheckoutDetails() {
        this.loading = true;
        var formData = new URLSearchParams();
        // Add header for the API
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          'Authorization': this.token
        };
        // AXIOS api call to add review api
        this.$axios.post("/api/offerOrders/app/checkout", formData, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.checkoutDetails = value;
            this.cartItems = this.checkoutDetails.offerCartItems
          })
          .catch(error => {
            this.$nextTick(() => {
              this.$router.push({
                path: '/'
              })
              this.loading = false;
            })
          })
          .finally(() => {
            this.$nextTick(() => {
              this.loading = false;
            })
          })
      },

      deleteFromCart(id) {
        // Clear all submit errors before API call
        this.deleteCartItem.formError = null;
        this.deleteCartItem.success = false;
        this.deleteCartItem.errored = false;
        this.deleteCartItem.loading = true;
        // Add header for the API
        const headers = {
          "Content-Type": "application/JSON",
          'Authorization': this.token
        };
        this.$axios.delete("/api/offerCarts/" + id, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.deleteCartItem.success = true;
            this.deleteCartItem.errored = false;
            this.checkoutDetails = value;
            this.cartItems = this.checkoutDetails.offerCartItems;
            if (this.cartItems && this.cartItems.length > 0) {
              this.getCheckoutDetails();
            } else {
              // this.$router.push({
              //   path: '/'
              // })
            }
          })
          .catch(error => {
            this.deleteCartItem.success = false;
            this.deleteCartItem.errored = true;
          })
          .finally(() => {
            this.deleteCartItem.loading = false;
          })
      },
      getTermsArr(terms) {
        let arr = terms.split("\n")
        arr = arr.filter(item => item);
        return arr
      },
      //------------------------------------------- CART FUNCTIONS END -------------------------------------------//


      //------------------------------------------- PAYMENT FUNCTIONS -------------------------------------------//
      createOrder() {
        this.orderButtonLoading = true;
        this.loading = true;
        var formData = new URLSearchParams();
        // Add header for the API
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          'Authorization': this.token
        };
        // AXIOS api call to add review api
        this.$axios.post("/api/offerOrders/app/createOfferOrder", formData, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.checkoutDetails = value;
            this.cartItems = this.checkoutDetails.cartItems
          })
          .catch(error => {
            this.$nextTick(() => {
              // this.$router.push({
              //   path: '/'
              // })
              this.loading = false;
            })
          })
          .finally(() => {
            this.$nextTick(() => {
              this.order()
            })
          })
      },

      // To initiate payment api and open the razorpay pop up, also handles success and failure
      order() {
        console.log("d", this.checkoutDetails.offerOrderId)
        this.errors.formError = null;
        this.orderButtonLoading = true;
        this.orderFailed = false;
        let date = new Date()
        const self = this;
        const rzp_options = {
          key: self.$config.rzpKey, // Enter the Key ID generated from the Dashboard
          amount: this.checkoutDetails.offerCartTotal *
            100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: "INR",
          name: "GOA APP",
          description: 'Secure payments',
          image: "https://goa.app/goa-razorpay.png",
          order_id: this.checkoutDetails
            .offerOrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
          handler: function (response) {
            self.orderButtonLoading = false;
            let orderId = response.razorpay_order_id ? response.razorpay_order_id : null;
            let paymentId = response.razorpay_payment_id ? response.razorpay_payment_id : null;
            let signature = response.razorpay_signature ? response.razorpay_signature : null;
            self.errors.formError = "Do not press back or refresh, payment processing.";
            self.verifyPayment(paymentId, orderId, signature);
            self.payment_id = response.razorpay_payment_id;
          },
          modal: {
            ondismiss: function () {
              self.errors.formError = null;
              self.orderButtonLoading = false;
            }
          },
          prefill: {
            email: this.profile && this.profile.email ? this.profile.email : '',
            contact: this.profile && this.profile.phone ? this.profile.phone : ''
          },
          notes: {
            name: "Date",
            item: date
          },
          theme: {
            color: "#ff9012"
          }
        };
        const rzp1 = new Razorpay(rzp_options);
        rzp1.open();
        rzp1.on('payment.failed', function (response) {
          this.orderFailed = true;
          this.errors.formError = null;
        });
      },
      // Final step to verify if payment is done and redirect to orders page
      verifyPayment(paymentId, orderId, signature) {
        this.orderButtonLoading = true;
        this.orderFailed = false;
        var formData = new URLSearchParams();
        formData.append("paymentId", paymentId);
        formData.append("orderId", orderId);
        formData.append("signature", signature);
        this.order_id = orderId;
        this.$router.push({
          path: '/offers-success/' + this.order_id
        })
        this.orderButtonLoading = false;
      },
      //------------------------------------------- PAYMENT FUNCTIONS END -------------------------------------------//
    }
  }
